<template>
	<div class="posts">
		<div class="contmenublog">
			<h2 class="section-title" id="eximusblog">Eximus Blog <img :src="require('@/assets/logo_eximus_mini_gray.png')" width="45px"/></h2>
			<div class="menublog">
				<div class="filtro">
					<div class="catcont">
						<div class="menu-button">
						<button @click="bShowBlogNav = !bShowBlogNav"><div class="fas fa-bars fa-fw"></div></button>
						</div>
						<div class="categoria">
							<router-link class="link" to="../posts">Tutti</router-link>
						</div>
						<div class="categoria">
							<router-link class="link" to="?categories=Eximus">Eximus</router-link>
						</div>
						<div class="categoria">
							<router-link class="link" to="?categories=Allenamento">Allenamento</router-link>
						</div>
						<div class="categoria">
							<router-link class="link" to="?categories=Wellness">Wellness</router-link>
						</div>
						<div class="categoria">
							<router-link class="link" to="?categories=Education">Education</router-link>
						</div>

						<div class="mobileblog" :class="{'show': bShowBlogNav}" @click="bShowBlogNav = false">
							<div class="mobile-nav">
								<router-link class="link t-uppercase" to="../posts">Tutti</router-link>
								<router-link class="link t-uppercase" to="?categories=Eximus">Eximus</router-link>
								<router-link class="link t-uppercase" to="?categories=Allenamento">Allenamento</router-link>
								<router-link class="link t-uppercase" to="?categories=Wellness">Wellness</router-link>
								<router-link class="link t-uppercase" to="?categories=Education">Education</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="results">
			<PostCard v-for="post in realPosts" :key="post.id" :data="post" :tags="tags" :categories="categories" class="post" @click.native="$router.push({name: 'post', params: {slug: post.slug}})"/>
		</div>
	</div>
</template>

<script>
import {Post} from '@/plugins/api'

export default {
	name: 'posts',

	components: {
		'PostCard': () => import('@/components/home/PostCard')
	},

	data() {

		return {
			posts: [],
			tags: {},
			categories: {},
			// Show blog navigation
			bShowBlogNav: false
		
		}
	},

	computed: {

		realPosts() {

			//posts = []
			//category = ['Wellness', 'Eximus']
			//for (let i = 0; i < this.posts.length; ++i)
			//{
			//	post = this.posts[i]
			//	if (category.indexOf(post.info_categories[0].name) != -1) posts.push(post)
			//}

			if (this.$route.query.categories)
			{
				const categories = this.$route.query.categories.split(',')
				return this.posts.filter((post) => {
					
					for (let catid of post.categories)
					{
						const name = this.categories[catid].name
						if (categories.indexOf(name) !== -1) return true
					}

					return false;
				})
			}
			else return this.posts
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

	async beforeRouteEnter(to, from, next) {

		try
		{
			// Fetch post
			let [posts, tags, categories] = await Promise.all([Post.all({_embed: null}), Post.tags(), Post.categories()])

			next((vm) => {

				vm.posts = posts
				tags.forEach((tag) => vm.tags[tag.id] = tag)
				categories.forEach((cat) => vm.categories[cat.id] = cat)
			})
		}
		catch (e)
		{
			notif.error(e)
			console.error(e)

			// Go back
			next(from)
		}
	},

	async beforeRouteUpdate(to, from, next) {

		try
		{
			// Fetch post
			let [posts, tags, categories] = await Promise.all([Post.all({_embed: null}), Post.tags(), Post.categories()])

			this.posts = posts
			tags.forEach((tag) => this.tags[tag.id] = tag)
			categories.forEach((cat) => this.categories[cat.id] = cat)
			next()
		}
		catch (e)
		{
			notif.error(e)
			console.error(e)

			// Go back
			next(from)
		}
	}
}
</script>

<style lang="stylus" scoped>
.post
	cursor pointer

.posts
	margin-bottom 3em
	
.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(767, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 520px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(767, px))
		width 100%
		display grid

.menu-button
			height 100%
			margin 0 auto
			display none 

			@media (min-width: unit(768, px))
				display none

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color #dcdcdc

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)

.mobileblog
	display none

	&.show
		display none

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

	@media (max-width: unit(767, px))
		color red	

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease

.link:hover
	color #ffe010

.results
	display grid
	grid-template-columns repeat(4, 1fr)
	grid-gap 1em

	@media (max-width: unit(1024, px))
		grid-template-columns repeat(2, 1fr)

	@media (max-width: unit(media-phone-max, px))
		display block

</style>